module.exports = __webpack_public_path__ + "media/images/emblems/Stans-coat_of_arms-e2b23a71647d11f063b0ca51f5043715.svg";